import axios from "axios";

const ENVS = {
  prod: "https://uac.edu.au/",
  test: "https://uaccms.uac.edu.au/",
  dev: "http://127.0.0.1:5000/",
};
const api = axios.create({ baseURL: ENVS.prod });
export default api;
